// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';
import Stripe                   from 'stripe';

const stripeApplyWebBookDiscount = async ({
    test,
    salePaymentIntentId,
    currPaymentIntentId,
}: {
    test: boolean,
    salePaymentIntentId: string,
    currPaymentIntentId: string,
}): Promise<Stripe.PaymentIntent | null> => {
    const functions = getFunctions();
    const applyDiscount = httpsCallable<
        {
            test: boolean,
            salePaymentIntentId: string,
            currPaymentIntentId: string,
        },
        Stripe.PaymentIntent | null
    >(
        functions,
        'stripeApplyWebBookDiscount',
    );

    return applyDiscount({
        test,
        salePaymentIntentId,
        currPaymentIntentId,
    }).then((result) => {
        const paymentIntent = result.data as Stripe.PaymentIntent | null;
        return paymentIntent;
    }).catch((err) => {
        throw err;
    });
};

export default stripeApplyWebBookDiscount;
